import { Alert, Col, Container, Row } from 'react-bootstrap';

import HashCode from '../hash-code/HashCode';
import React from 'react';
import StackTraceDecoder from '../stack-trace-decoder/StackTraceDecoder';
import KibanaUrls from '../kibana-urls/KibanaUrls';

const App = () => {
  return (
    <Container fluid className="w-100 p-0 m-0">
      <Container fluid>
        <Row>
          <Col>
            <Alert className="m-4" variant="warning">
              Expect this page to change randomly. For RTS team use only.
            </Alert>
          </Col>
        </Row>
        <hr />
        <KibanaUrls />
        <hr />
        <StackTraceDecoder />
        <hr />
        <HashCode />
      </Container>
    </Container>
  );
};

export default App;
